import React from 'react';
import formatLastSeen from '../../utils/presence/formatLastSeen';

function LastSeen({ timestamp }) {
  return <span>{formatLastSeen(timestamp)}</span>;
}

export default LastSeen;
